var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,_vm._b({tag:"component"},'component',{ configuration: _vm.config, isLoading: _vm.isLoading, subscribe: _vm.subscribe, clearState: _vm.clearState, theme: _vm.theme, message: _vm.message,
           state: _vm.state, formData: _vm.formData, data: _vm.data },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }